// Automatically expose env vars beginning with EPIC_CLIENT_ to client
export const copyClientEnvVariables = (envConfig, clientEnvConfig) => {
    Object.keys(envConfig).forEach(envVarKey => {
        if (/^EPIC_CLIENT_/.test(envVarKey)) {
            clientEnvConfig[envVarKey] = envConfig[envVarKey];
        }
    });
};

export default {
    copyClientEnvVariables
};
